// @flow
import env from '../../environment';
import {postCreator, getCreator} from '../../http';

export const endpoints = Object.freeze({
  PRODUCT_BATCH_TEMPLATE: `${env.baseApiUrl}/im/admin/batch-product/template`,
  UPDATE_PRODUCTS_BATCH: `${env.baseApiUrl}/im/admin/batch-product`,
  CREATE_PRODUCTS_BATCH: `${env.baseApiUrl}/im/admin/batch-product`,
  GET_PRODUCTS_BATCH_UPLOAD_STATUS: `${env.baseApiUrl}/im/admin/batch-product`,
});

export const updateProductsBatchApi = postCreator(
  endpoints.UPDATE_PRODUCTS_BATCH
);

export const createProductsBatchApi = postCreator(
  endpoints.CREATE_PRODUCTS_BATCH
);

export const getProductsBatchUploadStatusApi = getCreator(
  endpoints.GET_PRODUCTS_BATCH_UPLOAD_STATUS
);
